import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var paymentMethodVisaIcon = /*#__PURE__*/React.createElement("svg", {
  height: "35",
  width: "56",
  fill: "none",
  viewBox: "0 0 56 35",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M55 .5H1a.5.5 0 0 0-.5.5v33a.5.5 0 0 0 .5.5h54a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5Z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("path", {
  d: "m21.984 9.285-6.546 15.619h-4.27L7.945 12.44c-.196-.768-.366-1.05-.96-1.373C6.015 10.54 4.41 10.047 3 9.74l.096-.454H9.97c.876 0 1.664.584 1.863 1.593l1.7 9.037 4.205-10.63h4.245Zm16.734 10.52c.017-4.123-5.7-4.35-5.66-6.191.012-.56.545-1.157 1.713-1.309.58-.075 2.174-.133 3.983.7l.71-3.313C38.492 9.34 37.24 9 35.684 9c-3.993 0-6.803 2.123-6.827 5.163-.026 2.248 2.006 3.503 3.537 4.25 1.575.765 2.103 1.257 2.097 1.941-.011 1.048-1.256 1.51-2.42 1.529-2.03.03-3.208-.55-4.148-.987l-.732 3.422c.944.433 2.687.81 4.493.83 4.244 0 7.021-2.097 7.034-5.344Zm10.545 5.099H53L49.738 9.285H46.29c-.775 0-1.43.452-1.719 1.146l-6.063 14.473h4.243l.842-2.333h5.184l.487 2.333Zm-4.508-5.534 2.127-5.864 1.224 5.864h-3.35ZM27.757 9.285l-3.341 15.619h-4.04l3.342-15.619h4.039Z",
  fill: "#1434CB"
}), /*#__PURE__*/React.createElement("path", {
  d: "M55 .5H1a.5.5 0 0 0-.5.5v33a.5.5 0 0 0 .5.5h54a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5Z",
  stroke: "#D5D5D5"
}));

export { paymentMethodVisaIcon as default };
//# sourceMappingURL=paymentMethodVisaIcon.js.map
